<template>
    <div class="intro">
        <main-navigation/>


        <transition name="fade" mode="out-in">
            <div v-if="!selected" class="text-center">


                <h2>What kind of Porn do you like?</h2>
                <content-type-selector nav-class="justify-content-center"/>


                <h2>What are you most into?</h2>

                <div class="container mt-4">
                    <div class="row justify-content-md-center">
                        <div class="col-md-8">
                            <nav class="nav nav-pills justify-content-center bordered">
                                <a v-for="tag in tags"
                                   class="nav-link"
                                   :class="{active: selectedTags.includes(tag)}"
                                   href="#"
                                   @click.prevent="toggleTag(tag)">{{tag}}</a>
                            </nav>
                        </div>
                    </div>

                </div>

                <button class="btn btn-primary btn-lg mt-5" @click.prevent="start">Get Started!</button>
            </div>
            <div v-else>
                <div class="text-center">
                    <button class="btn btn-outline-primary" @click.prevent="backToTags"><icon icon="chevron-left"/> Select Tags</button>
                    <router-link :to="{name:'Dashboard'}" tag="button" class="btn btn-outline-primary" >Go to Dashboard <icon icon="chevron-right"/></router-link>
                </div>
                <blog-list :search="searchTags" headline="Pick a few blogs to follow"/>
            </div>
        </transition>
    </div>
</template>

<script>
    import MainNavigation from "../../layout/MainNavigation.vue";
    import BlogList from "../../blogs/BlogList.vue";
    import Icon from "../../ui/Icon";
    import ContentTypeSelector from "../../ui/buttons/ContentTypeSelector";

    export default {
        components: {
            ContentTypeSelector,
            Icon,
            MainNavigation,
            BlogList
        },
        name: "intro-page",
        data(){
            return {
                selected: false,
                tags: ['Teen', 'Milf', 'Lesbian', 'Anal', 'Squirting', 'Cumshots', 'Deepthroat', 'Blowjobs', 'Hentai', 'Black', 'Asian', 'Shemale', 'Gay'],
                selectedTags: []
            }
        },
        computed:{
            searchTags(){
                return this.selectedTags.join(' ');
            }
        },
        methods:{
            toggleTag(tag){
                if(this.selectedTags.includes(tag)){
                    const idx = this.selectedTags.indexOf(tag);
                    this.selectedTags.splice(idx, 1);
                } else {
                    this.selectedTags.push(tag);
                }
            },
            backToTags(){
                this.selected = false;
            },
            start(){
               this.selected = true;
            }

        }
    }
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/vars"

    .bordered
        a
            margin: .4em
            border: 1px solid

    .fade-enter-active, .fade-leave-active
        transition: opacity .5s

    .fade-enter, .fade-leave-to
        opacity: 0


</style>



// WEBPACK FOOTER //
// src/components/user/intro/IntroPage.vue